(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/grey/g, 'gray')
      .replace(/[^a-z0-9.]+/g, ' ')
      .trim();
  }

  function parseVariants(root, productKey) {
    var node = root.querySelector('[data-mrv-product="' + productKey + '"]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent.trim() || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function variantOptions(variant) {
    var options = Array.isArray(variant.options)
      ? variant.options
      : [variant.option1, variant.option2, variant.option3];
    return options.filter(Boolean).map(normalize);
  }

  function matchesSize(option, gallons) {
    var expression = new RegExp('(^|\\D)' + gallons + '\\s*(gal|gallon)');
    return expression.test(option);
  }

  function findVariant(variants, gallons, color) {
    var normalizedColor = normalize(color);
    return variants.find(function (variant) {
      if (variant.available === false) return false;
      var options = variantOptions(variant);
      var sizeMatches = gallons == null || options.some(function (option) { return matchesSize(option, gallons); });
      var colorMatches = !normalizedColor || options.some(function (option) {
        return option === normalizedColor || option.indexOf(normalizedColor) !== -1;
      });
      return sizeMatches && colorMatches;
    });
  }

  function firstAvailable(variants) {
    return variants.find(function (variant) { return variant.available !== false; }) || null;
  }

  function formatNumber(value) {
    return Number.isInteger(value) ? String(value) : value.toFixed(1);
  }

  function initialize(root) {
    if (!root || root.dataset.mrvInitialized === 'true') return;
    root.dataset.mrvInitialized = 'true';

    var elements = {
      length: root.querySelector('[data-mrv-length]'),
      width: root.querySelector('[data-mrv-width]'),
      roofType: root.querySelector('[data-mrv-roof-type]'),
      equation: root.querySelector('[data-mrv-equation]'),
      area: root.querySelector('[data-mrv-area]'),
      adhesion: root.querySelector('[data-mrv-adhesion]'),
      epdmNotice: root.querySelector('[data-mrv-epdm-notice]'),
      epdmProduct: root.querySelector('[data-mrv-epdm-product]'),
      summaryTitle: root.querySelector('[data-mrv-summary-title]'),
      gallons: root.querySelector('[data-mrv-gallons]'),
      topColorLabel: root.querySelector('[data-mrv-top-color-label]'),
      topQuantity: root.querySelector('[data-mrv-top-qty]'),
      flashingSize: root.querySelector('[data-mrv-flashing-size]'),
      epdmQuantity: root.querySelector('[data-mrv-epdm-qty]'),
      resultsInput: root.querySelector('[data-mrv-results-input]'),
      resultsText: root.querySelector('[data-mrv-results-text]'),
      cartButton: root.querySelector('[data-mrv-add-cart]'),
      cartStatus: root.querySelector('[data-mrv-cart-status]')
    };

    var state = {
      topColor: 'White',
      flashingColor: 'White',
      calculation: null
    };

    var products = {
      topCoat: parseVariants(root, 'top-coat'),
      flashing: parseVariants(root, 'flashing'),
      epdm: parseVariants(root, 'epdm')
    };

    function updateColor(groupSelector, stateKey, button) {
      root.querySelectorAll(groupSelector + ' [data-color]').forEach(function (choice) {
        var selected = choice === button;
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      state[stateKey] = button.dataset.color;
      update();
    }

    root.querySelectorAll('[data-mrv-top-colors] [data-color]').forEach(function (button) {
      button.addEventListener('click', function () { updateColor('[data-mrv-top-colors]', 'topColor', button); });
    });
    root.querySelectorAll('[data-mrv-flashing-colors] [data-color]').forEach(function (button) {
      button.addEventListener('click', function () { updateColor('[data-mrv-flashing-colors]', 'flashingColor', button); });
    });

    function update() {
      var length = Math.max(0, Number(elements.length.value) || 0);
      var width = Math.max(0, Number(elements.width.value) || 0);
      var roofType = elements.roofType.value;
      var area = length * width;
      var gallons = area > 0 ? Math.ceil(area / 60) : 0;
      var fiveGallonPails = Math.floor(gallons / 5);
      var oneGallonPails = gallons % 5;
      var flashingGallons = Number(elements.flashingSize.value);
      var epdmGallons = area > 0 ? Math.ceil(area / 400) : 0;
      var isEpdm = roofType === 'EPDM Rubber';
      var needsAdhesionTest = roofType === 'TPO' || roofType === 'PVC';

      state.calculation = {
        length: length,
        width: width,
        roofType: roofType,
        area: area,
        gallons: gallons,
        fiveGallonPails: fiveGallonPails,
        oneGallonPails: oneGallonPails,
        flashingGallons: flashingGallons,
        epdmGallons: epdmGallons,
        isEpdm: isEpdm
      };

      elements.equation.textContent = formatNumber(length) + ' ft × ' + formatNumber(width) + ' ft';
      elements.area.textContent = formatNumber(area) + ' sq. ft.';
      elements.summaryTitle.textContent = Math.round(area) + ' sq. ft. ' + roofType + ' roof';
      elements.gallons.textContent = gallons;
      elements.topColorLabel.textContent = state.topColor;
      elements.adhesion.hidden = !needsAdhesionTest;
      elements.epdmNotice.hidden = !isEpdm;
      elements.epdmProduct.hidden = !isEpdm;
      elements.epdmQuantity.textContent = epdmGallons + ' × 1 gal';

      elements.topQuantity.innerHTML = '';
      if (fiveGallonPails > 0) {
        var five = document.createElement('span');
        five.textContent = fiveGallonPails + ' × 5 gal';
        elements.topQuantity.appendChild(five);
      }
      if (oneGallonPails > 0) {
        var one = document.createElement('span');
        one.textContent = oneGallonPails + ' × 1 gal';
        elements.topQuantity.appendChild(one);
      }

      var resultParts = [
        Math.round(area) + ' sq. ft.',
        roofType,
        gallons + ' gal Top Coat',
        flashingGallons + ' gal Flashing'
      ];
      if (isEpdm) resultParts.push(epdmGallons + ' gal EPDM Rinse');
      elements.resultsText.textContent = resultParts.join(' • ');
      elements.resultsInput.value = resultParts.join(' | ');
    }

    [elements.length, elements.width].forEach(function (input) {
      input.addEventListener('input', update);
    });
    elements.roofType.addEventListener('change', update);
    elements.flashingSize.addEventListener('change', update);

    function showCartStatus(message, isError) {
      elements.cartStatus.hidden = false;
      elements.cartStatus.textContent = message;
      elements.cartStatus.classList.toggle('is-error', Boolean(isError));
    }

    function requireVariant(variants, gallons, color, label) {
      var variant = findVariant(variants, gallons, color);
      if (!variant) throw new Error('No available ' + label + ' variant matched ' + color + ', ' + gallons + ' gallon. Check the product selection and option names in the theme editor.');
      return variant;
    }

    elements.cartButton.addEventListener('click', function () {
      var calculation = state.calculation;
      if (!calculation || calculation.area <= 0) {
        showCartStatus('Enter valid roof dimensions before adding the system.', true);
        return;
      }

      var items = [];
      try {
        if (calculation.fiveGallonPails > 0) {
          items.push({
            id: requireVariant(products.topCoat, 5, state.topColor, 'Top Coat').id,
            quantity: calculation.fiveGallonPails
          });
        }
        if (calculation.oneGallonPails > 0) {
          items.push({
            id: requireVariant(products.topCoat, 1, state.topColor, 'Top Coat').id,
            quantity: calculation.oneGallonPails
          });
        }

        items.push({
          id: requireVariant(products.flashing, calculation.flashingGallons, state.flashingColor, 'Flashing Grade').id,
          quantity: 1
        });

        if (calculation.isEpdm) {
          var epdmVariant = findVariant(products.epdm, 1, '') || firstAvailable(products.epdm);
          if (!epdmVariant) throw new Error('No available EPDM Rinse Cleaner variant was found. Check the product selection in the theme editor.');
          items.push({ id: epdmVariant.id, quantity: calculation.epdmGallons });
        }
      } catch (error) {
        showCartStatus(error.message, true);
        return;
      }

      elements.cartButton.disabled = true;
      elements.cartButton.textContent = 'Adding your system…';
      showCartStatus('Adding the calculated products to your cart…', false);

      var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Shopify could not add this system to the cart.'); });
          return response.json();
        })
        .then(function () {
          window.location.assign(rootUrl + 'cart');
        })
        .catch(function (error) {
          showCartStatus(error.message || 'The system could not be added. Please try again.', true);
          elements.cartButton.disabled = false;
          elements.cartButton.textContent = 'Add My System to Cart';
        });
    });

    update();
  }

  function initializeAll(scope) {
    if (scope.matches && scope.matches('[data-mrv-builder]')) initialize(scope);
    scope.querySelectorAll('[data-mrv-builder]').forEach(initialize);
  }

  initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();
